interface NotificationBlockedBannerProps {
  message: string;
}

export function NotificationBlockedBanner({ message }: NotificationBlockedBannerProps) {
  return (
    <div
      role="alert"
      className="install-description mt-6 rounded-lg border px-4 py-3 text-sm bg-(--bc-color-warning-subtle,rgba(234,179,8,0.15)) border-(--bc-color-warning,#eab308) text-(--bc-color-warning-contrast,#713f12)"
    >
      {message}
    </div>
  );
}
